const spiritualGifts = [
  {
    letter: 'a',
    gift: 'Administración',
    text: 'El don de la administración es la habilidad sobrenatural de organizar múltiples tareas y grupos de personas para cumplir tareas específicas. <span>Lucas 14: 28-30; Hechos 6: 1-7; 1 Coríntios 12: 28.</span>',
  },
  {
    letter: 'b',
    gift: 'Plantación de iglesias',
    text: 'Es el don para incursionar en nuevas iglesias y ministerios a través de la plantación, supervisión, entrenamiento y discipulado de personas. <span>Hechos 15: 22- 35; 1 Coríntios 12: 28; 2 Coríntios 12:12; Gálatas 2: 7- 10; Efesios 4: 11-14.</span>',
  },
  {
    letter: 'c',
    gift: 'Artesanía',
    text: 'El don de la artesanía es la habilidad sobrenatural de planear, construir y trabajar con tus propias manos en el ambiente constructivo de cumplir múltiples aplicaciones ministeriales. <span>Éxodo 30:22, 31:3-11, 2 Crónicas 34:9-13, Hechos 18:2-3.</span>',
  },
  {
    letter: 'd',
    gift: 'Discernimiento',
    text: 'El don del discernimiento es la capacidad divina para identificar espiritualmente falsedad y distinguir entre las intenciones y motivaciones correctas y negativas. <span>Mateo 16: 21- 23; Hechos 5:1-11, 16: 16- 18; 1 Coríntios 12: 10; 1 Juan 4: 1-6.</span>',
  },
  {
    letter: 'e',
    gift: 'Evangelismo',
    text: 'El don del evangelismo es la capacidad y el llamado sobrenatural de compartir las buenas noticias de Jesús.  <span>Hechos 8: 5-6, 8: 26-40, 14: 21; 21:8; Efesios 4: 11- 14.</span>',
  },
  {
    letter: 'f',
    gift: 'Animar',
    text: 'El don de animar es la capacidad divina para retar y fortalecer a otros a través de palabras sustentadas en la Escritura.<span>Hechos 14: 22; Romanos 12: 8; 1 Timoteo 4: 13; Hebreos 10: 24-25</span>',
  },
  {
    letter: 'g',
    gift: 'Fe',
    text: 'El don de la fe es la expectativa sobrenatural de creer en Dios por las cosas que no se ven, y que cumplirá todo lo que ha prometido. <span>Hebreos 11; Romanos 4: 18-21; 1 Coríntios 12:9.</span>',
  },
  {
    letter: 'h',
    gift: 'Dar',
    text: 'El don de Dar es la habilidad sobrenatural de producir abundancia para diezmar y ofrendar con el propósito de expandir el Reino de Dios en la tierra.  <span>Marcos 12: 41-44; Romanos 12: 8; 2 Coríntios 8: 1-7, 9: 2-7</span>',
  },
  {
    letter: 'i',
    gift: 'Sanidad',
    text: ' El don de la sanidad es la fortaleza divina de actuar como intermediario de la fe, orador e imposición de manos para traer sanidad tanto física, mental y psicológicamente. <span>Hechos 3: 1-10; 9: 32-35; 28: 7-10; 1 Coríntios 12:9, 28.</span>',
  },
  {
    letter: 'j',
    gift: 'Servicio',
    text: 'El don de servicio es la capacidad sobrenatural de trabajar como apoyo para el cumplimiento de tareas grandes o pequeñas en el ministerio cristiano.<span>Marcos 15: 40-41; Hechos 9: 36, Romanos 16: 1- 2; 1 Coríntios 12: 28, Hechos 6: 1-7 </span>',
  },
  {
    letter: 'k',
    gift: 'Hospitalidad',
    text: 'El don de la Hospitalidad es la fortaleza divina de crear ambientes cálidos y acogedores en lugares como la casa, la oficina o la iglesia. <span>Hechos 16: 14-15; Romanos 12: 13; Hebreos 13:1-2; 1 Pedro 4:9</span>',
  },
  {
    letter: 'l',
    gift: 'Oración',
    text: 'El don de la oración es la fortaleza sobrenatural para pararse en la brecha y orar por alguien, algo o algún lugar, creyendo por resultados definitivos <span>Hebreos 7: 25; Colosenses 1: 9-12, 4:12-13; Santiago 5: 14-16.  </span>',
  },
  {
    letter: 'm',
    gift: 'Conocimiento',
    text: 'El don de conocimiento es la fortaleza divina de entender y traer claridad a situaciones y circunstancias sustentadas por una palabra del Señor <span>Hechos 5:1-11; 1 Coríntios 12:8; Colosenses 2:2-3</span>',
  },
  {
    letter: 'n',
    gift: 'Liderazgo',
    text: 'El don del liderazgo es la habilidad divina de influenciar personas en niveles de liderazgo mientras se les dirige y se les enfoca en la visión general, amplia. <span>Romanos 12:8; 1Timoteo 3: 1-13, 5:17; Hebreos 13:17</span>',
  },
  {
    letter: 'ñ',
    gift: 'Compasión',
    text: 'El don de la compasión es la habilidad sobrenatural de sentir empatía y cuidado por aquellos que han sido heridos y tomar la iniciativa de ayudarlos. <span>Mateo 9: 35-36; Marcos 9:41; Romanos 12:8; 1 Tesalonicenses 5:14. </span>',
  },
  {
    letter: 'o',
    gift: 'Milagros',
    text: 'El don de los milagros es la fortaleza divina o la habilidad para alterar los resultados naturales de la vida de una manera sobrenatural a través de la oración, la fe y la dirección divina. <span>Hechos 9:36-42, 19:11-12, 20: 7-12; Romanos 15: 18-19; 1 Coríntios 12: 10, 28.</span>',
  },
  {
    letter: 'p',
    gift: 'Misiones',
    text: 'El don de las misiones es la habilidad sobrenatural de alcanzar a otros más allá de tu cultura y/o nacionalidad, en la mayoría de casos viviendo en una cultura o nación específica. <span>Hechos 8:4, 13:2-3, 22:21; Romanos 10:5. </span>',
  },
  {
    letter: 'q',
    gift: 'Música / adoración',
    text: 'El don de la alabanza/adoración es la fortaleza divina para cantar, danzar o interpretar algún instrumento principalmente para conducir a otros a adorar al Señor.<span>Deuteronomio 31:22; 1 Samuel 16:16; 1 Crónicas 16:41-42; 2 Crónicas 5:12-13, 34:12; Salmo 150.</span>',
  },
  {
    letter: 'r',
    gift: 'Pastor',
    text: 'El don de pastor es la divina habilidad de cuidar las necesidades personales de otros por medio del fomento y la reparación de problemas de la vida. <span>Juan 10:1-18; Efesios 4:11-14; 1 Timoteo 3: 1-7; 1 Pedro 5: 1-3.</span>',
  },
  {
    letter: 's',
    gift: 'Profecía',
    text: 'El don de la profecía es la fortaleza divina de hablar confiadamente y traer claridad a la verdad bíblica y doctrinal, en algunos casos prediciendo el plan de Dios.  <span>Hechos 2: 37-40, 7: 51-53, 26: 24-29; 1 Coríntios 14: 1-4; 1 Tesalonicenses 1:5</span>',
  },
  {
    letter: 't',
    gift: 'Gobernar',
    text: 'EL don de gobernar es la habilidad sobrenatural para servir y tener influencia política para el bien del pueblo. <span> Daniel 1:20, Ester 4:14, Mateo 20:26. </span>',
  },
  {
    letter: 'u',
    gift: 'Enseñanza',
    text: 'El don de la enseñanza es la fortaleza divina para estudiar y aprender de las Escrituras principalmente para contribuir a la comprensión y el crecimiento de otros cristianos. <span>Hechos 18:24-28; 20, 20:20-21, 1 Coríntios 12:28; Efesios 4: 11-14.</span>',
  },
  {
    letter: 'v',
    gift: 'Idiomas desconocidos',
    text: 'El don de idiomas desconocidos (en el griego glosolalia, también conocido como el don de hablar en lenguas) es la capacidad o habilidad de orar en un lenguaje celestial para fortalecerse a sí mismo y hablar con Dios. El don de idiomas desconocidos es a menudo acompañado por la interpretación y debe ser utilizado apropiadamente. <span>1 Coríntios 14:1-14; Hechos 2:1-13; 1 Coríntios 12: 10.</span>',
  },
  {
    letter: 'w',
    gift: 'Sabiduría',
    text: 'El don de la sabiduría es la fuerza o habilidad divina para aplicar las verdades de la Escritura de una manera práctica, produciendo un resultado fructífero además del reflejo del carácter de Jesucristo.<span> Hechos 6:3,10; 1 Coríntios 2: 6-13, 12:8.</span>',
  },
];

const spiritualQuestions = [
  { letter: 'a', num: 1, question: 'Disfruto organizar servicios y eventos.' },
  { letter: 'b', num: 2, question: 'Disfruto ser un pionero en nuevos proyectos.' },
  { letter: 'c', num: 3, question: 'Trabajar con mis propias manos es divertido para mí.' },
  { letter: 'd', num: 4, question: 'Puedo discernir cuando alguien no es sincero.' },
  { letter: 'e', num: 5, question: 'Oro por los necesitados cada día.' },
  { letter: 'f', num: 6, question: 'Animar y retar a otros es una prioridad en mi vida.' },
  { letter: 'g', num: 7, question: 'Creo que el Señor proveerá mis necesidades diarias.' },
  {
    letter: 'h',
    num: 8,
    question: 'Ayudar a otros a través de las finanzas es extremadamente importante para mí.',
  },
  { letter: 'i', num: 9, question: 'Aprovecho cada oportunidad para orar por los enfermos.' },
  { letter: 'j', num: 10, question: 'Disfruto servir en pequeñas tareas que otros evitan.' },
  {
    letter: 'k',
    num: 11,
    question: 'Recibir personas en mi hogar es algo que realizo con frecuencia.',
  },
  { letter: 'l', num: 12, question: 'Disfruto pasar tiempo orando por otros.' },
  { letter: 'm', num: 13, question: 'La educación es muy importante para mi vida.' },
  {
    letter: 'n',
    num: 14,
    question: 'Mi enfoque se encuentra en motivar a otros para que se involucren más.',
  },
  { letter: 'ñ', num: 15, question: 'Me duele ver a otros afligidos.' },
  { letter: 'o', num: 16, question: 'Creo que Dios quiere hacer milagros a través de mí.' },
  { letter: 'p', num: 17, question: 'Disfruto compartir el evangelio con otras personas.' },
  {
    letter: 'q',
    num: 18,
    question: 'He dedicado tiempo para mejorar mi voz y/o manejo de algún instrumento.',
  },
  {
    letter: 'r',
    num: 19,
    question: 'Cuidar de una persona emocionalmente herida es una prioridad en mi vida.',
  },
  {
    letter: 's',
    num: 20,
    question: 'En ocasiones Dios me muestra el gran destino que hay en otras personas.',
  },
  {
    letter: 't',
    num: 21,
    question: 'Tengo un celo por la defensa de los principios y valores cristianos en la sociedad.',
  },
  { letter: 'u', num: 22, question: 'Me gusta crear diagramas y/o bosquejos de la biblia.' },
  { letter: 'v', num: 23, question: 'Dios me ha usado para interpretar idiomas desconocidos.' },
  { letter: 'w', num: 24, question: 'Disfruto leer el libro de Proverbios.' },
  { letter: 'a', num: 25, question: 'Me apasiona coordinar cada detalle.' },
  { letter: 'b', num: 26, question: 'Disfruto supervisar y entrenar otras personas.' },
  { letter: 'c', num: 27, question: 'Me considero un artesano o artesana. ' },
  {
    letter: 'd',
    num: 28,
    question: 'Siento cuando hay situaciones que son espiritualmente malsanas.',
  },
  { letter: 'e', num: 29, question: 'Me inquieto por ver personas llegando a Cristo.' },
  { letter: 'f', num: 30, question: 'Procuro ser cuidadoso y amoroso.' },
  { letter: 'g', num: 31, question: 'Creer en Dios para que cumpla grandes cosas, me emociona.' },
  { letter: 'h', num: 32, question: 'Busco formas de dar más allá del diezmo.' },
  { letter: 'i', num: 33, question: 'Creo que los milagros y sanidades ocurren hoy en día.' },
  { letter: 'j', num: 34, question: 'Ayudar a los demás es uno de mis mayores logros.' },
  { letter: 'k', num: 35, question: 'Crear un ambiente cálido es muy importante para mí.' },
  {
    letter: 'l',
    num: 36,
    question: 'Siento carga por las situaciones que le suceden al mundo y busco orar por ellas.',
  },
  {
    letter: 'm',
    num: 37,
    question: 'Las personas constantemente me buscan para que les enseñe más acerca de Dios.',
  },
  { letter: 'n', num: 38, question: 'Tomo liderazgo en situaciones cuando es necesario.' },
  { letter: 'ñ', num: 39, question: 'Soy sensible ante las dificultades de los demás.' },
  { letter: 'o', num: 40, question: 'Frecuentemente suceden milagros cuando estoy cerca.' },
  {
    letter: 'p',
    num: 41,
    question: 'Vivir en otros países para difundir el evangelio me emociona.',
  },
  { letter: 'q', num: 42, question: 'Deseo servir a Dios a través de la alabanza.' },
  { letter: 'r', num: 43, question: 'Disfruto conectar, cuidar y discipular a otros.' },
  {
    letter: 's',
    num: 44,
    question: 'Tengo facilidad para confrontar y ayudar un amigo si se encuentra en pecado.',
  },
  {
    letter: 't',
    num: 45,
    question:
      'Tengo ideas y/o proyectos aplicables en espacios políticos que pueden traer bienestar a mi ciudad.',
  },
  {
    letter: 'u',
    num: 46,
    question:
      'Comparto verdades bíblicas con otros con el deseo de que sean de bendición para sus vidas.',
  },
  { letter: 'v', num: 47, question: 'Me gusta orar en idiomas desconocidos (lenguas) cada día.' },
  { letter: 'w', num: 48, question: 'Cuando estudio las escrituras, Dios me revela cosas únicas.' },
  {
    letter: 'a',
    num: 49,
    question: 'Crear una lista de tareas me es más fácil y disfruto cumplirla.',
  },
  {
    letter: 'b',
    num: 50,
    question: 'Me llama la atención los ministerios que tienen que ver con crear nuevas iglesias.',
  },
  { letter: 'c', num: 51, question: 'Construir algo con mis propias manos es muy gratificante.' },
  {
    letter: 'd',
    num: 52,
    question: 'Puedo determinar con precisión dificultades o problemas antes que otros.',
  },
  { letter: 'e', num: 53, question: 'Disfruto compartir el evangelio con un completo extraño.' },
  { letter: 'f', num: 54, question: 'Busco maneras de ser influyente para otras personas.' },
  {
    letter: 'g',
    num: 55,
    question: 'Confío plenamente que Dios tiene control de cada situación en mi vida.',
  },
  { letter: 'h', num: 56, question: 'Obtener más dinero significa que puedo ofrendar más.' },
  {
    letter: 'i',
    num: 57,
    question: 'Dios me ha usado para traer sanidad a aquellos que están enfermos.',
  },
  { letter: 'j', num: 58, question: 'Me incomoda cuando alguien no quiere participar.' },
  {
    letter: 'k',
    num: 59,
    question: 'Con frecuencia tengo facilidad de hacer sentir a la gente como en casa.',
  },
  { letter: 'l', num: 60, question: 'La gente normalmente me describe como un intercesor.' },
  {
    letter: 'm',
    num: 61,
    question: 'Disfruto escudriñar la Biblia y ayudar a otros a entenderla.',
  },
  { letter: 'n', num: 62, question: 'Delego responsabilidades para poder cumplir tareas.' },
  { letter: 'ñ', num: 63, question: 'Me motiva ayudar a los menos afortunados.' },
  {
    letter: 'o',
    num: 64,
    question: 'Tengo un hambre constante por ver el poder milagroso de Dios.',
  },
  { letter: 'p', num: 65, question: 'Me enfoco especialmente en alcanzar el mundo para Cristo.' },
  {
    letter: 'q',
    num: 66,
    question: 'Me llena de satisfacción dirigir a otros en la alabanza.(instrumentos o vocal).',
  },
  { letter: 'r', num: 67, question: 'Disfruto acompañar a aquellos en momentos de dificultad.' },
  {
    letter: 's',
    num: 68,
    question: 'Disfruto tomar apuntes de una apasionante y honesta prédica.',
  },
  {
    letter: 't',
    num: 69,
    question:
      'Le pido al Señor que me permita ser un instrumento para cambiar la ciudad a través de la política.',
  },
  { letter: 'u', num: 70, question: 'Me gusta enseñar la Biblia en formas prácticas y creativas.' },
  {
    letter: 'v',
    num: 71,
    question: 'Orar en el Espíritu es importante y un gran reto en mi vida.',
  },
  {
    letter: 'w',
    num: 72,
    question:
      'Cuando atravieso un momento de dificultad trato de tomar decisiones sabias y acertadas.',
  },
];

export { spiritualGifts, spiritualQuestions };
